import { ThemeIcon } from '@mantine/core';

import { IconRepeat } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Badge } from '../Badge/Badge';
import { Tooltip } from '../Tooltip/Tooltip';

type SizeParams = 'xs' | 'lg';

type RenewalTagProps = {
  size?: SizeParams;
};

export function RenewalTag({ size = 'lg' }: RenewalTagProps) {
  const { t } = useTranslation('domain');
  if (size === 'xs') {
    return (
      <Tooltip width="166px" content={t('tender.renewal')}>
        <Badge
          leftIcon={
            <ThemeIcon size={20} c="primary" color="transparent" px={0}>
              <IconRepeat size={16} />
            </ThemeIcon>
          }
          color="primary"
        />
      </Tooltip>
    );
  }
  return (
    <Badge
      leftIcon={
        <ThemeIcon size={20} c="primary" color="transparent" px={0}>
          <IconRepeat size={16} />
        </ThemeIcon>
      }
      size="lg"
      content={t('tender.renewal')}
      color="primary"
      textTransform="none"
    />
  );
}
